import { render, staticRenderFns } from "./LeftSide.vue?vue&type=template&id=12340580&scoped=true"
import script from "./LeftSide.vue?vue&type=script&lang=js"
export * from "./LeftSide.vue?vue&type=script&lang=js"
import style0 from "./LeftSide.vue?vue&type=style&index=0&id=12340580&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12340580",
  null
  
)

export default component.exports